import React from 'react';

export default function LoadingOverlay({ text }) {
  return /*#__PURE__*/(
    React.createElement("div", { className: "absolute left-0 top-0 right-0 bottom-0 z-50 bg-white bg-opacity-50 flex items-center justify-center" }, /*#__PURE__*/
    React.createElement("div", { className: "flex flex-col items-center space-y-4 text-center" }, /*#__PURE__*/
    React.createElement("div", { className: "border-[3px] border-indigo-300 border-t-indigo-600 w-8 h-8 rounded-full animate-spin" }),
    text ? /*#__PURE__*/React.createElement("p", { className: "text-sm text-indigo-700 mt-2" }, text) : undefined)));



}